import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { FornecedorList } from '../../core/_models'
import { FornecedoresColumns } from './columns/_columns'

export const FornecedoresTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => FornecedoresColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={t('pagina.fornecedores.vazio.filtro_titulo')}
      description={t('pagina.fornecedores.vazio.filtro_descricao')}
      action={{ label: t('pagina.dispositivos.limpar_filtros'), onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title={t('pagina.fornecedores.vazio.titulo')}
      description={t('pagina.fornecedores.vazio.descricao')}
    />
  )

  return (
    <CustomTable<FornecedorList>
      id='kt_table_fornecedores'
      ariaLabel={t('menu.fornecedores')}
      itemLabel={{ singular: 'fornecedor', plural: 'fornecedores' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
